import { SourcePages, EventType, Features } from 'lib/EventSchema';
import { EventData, VdpEventData } from 'lib/EventLogger/Event';
import { VehicleEventInfo } from '../../types';

function event({ trackingParams }: VehicleEventInfo): EventData & VdpEventData {
  return {
    event_type: EventType.engagement,
    engagement_type: 'close_tap',
    source_page: SourcePages.VdpPhotoSlideshow,
    feature: Features.slideshow,
    event_context: {
      tracking_params: trackingParams,
    },
  };
}

export default event;
